import { Link } from 'react-router-dom';
import { ArrowRight, BadgeCheck, MapPin } from 'lucide-react';
import { useLang } from '../i18n';
import { PriceOnRequest } from './PriceOnRequest';

export const PartnerCard = ({ partner, typeLabel, testid, showPrice = false, cta }) => {
  const { t } = useLang();
  return (
    <Link to={`/partners/${partner.id}`} data-testid={testid} className="group eco-card flex h-full flex-col p-5">
      <p className="text-[12px] font-semibold uppercase tracking-[0.14em] text-eco-gold">{partner.island} · {typeLabel}</p>
      <div className="mt-3 flex items-start gap-3">
        <span className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-eco-green text-lg font-semibold text-eco-gold">{partner.name.charAt(0)}</span>
        <div className="min-w-0">
          <h3 className="eco-card-title truncate">{partner.name}</h3>
          <p className="eco-meta mt-1 flex items-center gap-1.5"><MapPin size={13} /> {partner.island}</p>
          {(partner.status === 'ACTIVE' || partner.status === 'VERIFIED') && (
            <span data-testid={`${testid}-badge`} className="mt-1.5 inline-flex items-center gap-1 rounded-full bg-eco-green/10 px-2.5 py-0.5 text-[11px] font-semibold text-eco-green">
              <BadgeCheck size={11} /> {partner.status === 'VERIFIED' ? t('partner.badge.verified') : t('partner.badge.active')}
            </span>
          )}
        </div>
      </div>
      <p className="eco-secondary mt-4 flex-1 text-eco-ink/60">{partner.description}</p>
      {showPrice && <div className="mt-4"><PriceOnRequest compact testid={`${testid}-price`} /></div>}
      <div className="mt-4 flex items-center justify-between border-t border-eco-ink/10 pt-4">
        <span className="flex items-center gap-1.5 text-[13px] font-medium text-eco-green"><BadgeCheck size={14} /> {typeLabel}</span>
        <span className="eco-btn-text">{cta || t('nav.explore')} <ArrowRight size={14} className="transition-transform duration-200 group-hover:translate-x-1" /></span>
      </div>
    </Link>
  );
};
